export default __webpack_public_path__ + "static/media/03_DAIF_Eco_01_01_end.88cebb90.jpg";